import { cn } from "../utils/cn"

export const tabsDefaultClassName = {
  tabsListClassName: 'w-full bg-transparent rounded-none',
  tabsTriggerClassName: 'h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800',
  tabsContentClassName: 'mt-6',
}

export const tabsDefaultWithFlexGrowClassName = {
  ...tabsDefaultClassName,
  tabsClassName: 'flex-1 flex flex-col',
  tabsContentClassName: cn(tabsDefaultClassName.tabsContentClassName, 'flex-1 [data-state="active"]:flex flex-col overflow-auto'),
}
